import classNames from "classnames";
import { FC } from "react";

import Img from "@components/FileServer/Img";

interface Logo {
  url: string;
  name: string;
}

interface LogoBoxProps {
  logos: Logo[];
}

const LogoBox: FC<LogoBoxProps> = ({ logos }) => {
  const uniqueLogos = logos.filter(
    (logo, index) => logos.findIndex(({ url }) => url === logo.url) === index
  );

  return (
    <div
      className={classNames("flight-segment-airline-logos", {
        "flight-segment-airline-logos--single": uniqueLogos.length <= 1,
        "flight-segment-airline-logos--double": uniqueLogos.length === 2,
        "flight-segment-airline-logos--multiple": uniqueLogos.length > 2,
      })}
    >
      {uniqueLogos.map((logo) => (
        <div className="flight-segment-airline-logo-height" key={logo.url}>
          <Img
            alt={logo.name}
            className={classNames("flight-segment-airline-logo", {
              "flight-segment-airline-logo--large": uniqueLogos.length === 1,
            })}
            src={logo.url}
            title={logo.name}
          />
        </div>
      ))}
    </div>
  );
};

export default LogoBox;
